import { getSiteUrl } from 'lib/utils/Environment';
import { extractPostcode } from 'shared/utils/helpers';

import { type AutoCompleteCategory } from './HeroAutoComplete';

type AutoCompleteBehaviorProps = {
  redirectToFullPageJobForm?: boolean;
  setSelectedLocationOption: (value: {
    value: string | null;
    valid: boolean;
    id: string | null;
  }) => void;
  locationOptions: Array<{
    value: string;
    id: string | number;
  }>;
  category: AutoCompleteCategory;
  handleJobFormLaunch: ({
    locationId,
    locationName
  }: {
    locationId: string | number;
    locationName: string;
  }) => Promise<void>;
};

const SITE_URL = getSiteUrl();
const useAutoCompleteSelectBehaviour = ({
  redirectToFullPageJobForm,
  locationOptions,
  category,
  setSelectedLocationOption,
  handleJobFormLaunch
}: AutoCompleteBehaviorProps) => {
  if (redirectToFullPageJobForm) {
    const goToFullPageJobForm = async (option) => {
      if (!option.isMenuOpen) {
        return null;
      }
      const selectedOption = locationOptions.find(
        (item) => item.value === option.value
      );
      const postcode = extractPostcode(selectedOption.value);
      window.location.href = `${SITE_URL}/get-free-quotes/${category.slug}?postcode=${postcode}`;
    };

    return {
      handleSelect: goToFullPageJobForm
    };
  }

  const openJobFormModal = async (option) => {
    if (!option.isMenuOpen) {
      return null;
    }
    const selectedOption = locationOptions.find(
      (item) => item.value === option.value
    );
    setSelectedLocationOption({
      value: selectedOption.value,
      valid: Boolean(location),
      id: String(selectedOption.id)
    });
    handleJobFormLaunch({
      locationId: selectedOption.id,
      locationName: selectedOption.value
    });
  };
  return {
    handleSelect: openJobFormModal
  };
};

export { useAutoCompleteSelectBehaviour };
